import { Heading } from "@chakra-ui/core";
import React, { Fragment, useState } from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

type FAQ = {
  question: string;
  answer: string;
};

const faqsList: FAQ[] = [
  {
    question: "What services are not included?",
    answer: `
    - Oven hood filter
    - Deep stain removal from doors & walls
    - Unclogging drains / pipes
    - Moving heavy furniture (including bulky trash)
    - Anything above 180cm
    `,
  },
  {
    question: "Does my property need to be unfurnished?",
    answer: `Yes. In order to provide an efficient service, we need apartments to be fully unfurnished 
    before we get started.`,
  },
  {
    question: "Can you clean or remove mold?",
    answer: `Under certain circumstances we can try cleaning mold, but we cannot guarantee its removal. 
    Often times this task requires a specialist's assessment and treatment.`,
  },
  {
    question: "What is the Happiness Guarantee?",
    answer: `We provide a 24-hour reclean guarantee on all our cleans. If you or your landlord are unhappy with any 
    aspect of our cleaning, we'll return to the property – no extra charge. 
    Subject to certain [terms and conditions](/terms)`,
  },
  {
    question: "Need more help?",
    answer: `
Hello, how can we help?  
Can't find the answer you’re looking for?  
Call us at [(929) 497-4111](tel:(929)497-4111) or email [support@heyhomero.com](mailto:support@heyhomero.com) and we’ll answer your queries!
        `,
  },
];

const Faq = styled.div`
  background: #fff;
  border: 1px solid #6fd4ea;
  box-shadow: 0px 24px 64px rgba(22, 27, 45, 0.05);
  border-radius: 10px;
  padding: 1rem 2rem;
  margin-top: 25px;
  text-align: left;

  img {
    width: 1.5rem;
  }

  p {
    width: 80%;
    line-height: 25px;
  }

  ul li {
    list-style: none;
    font-size: 0.9rem;
    line-height: 25px;
    opacity: 0.8;
  }

  ol li {
    margin: 4px 0 8px 20px;
    opacity: 0.8;
  }

  code {
    font-family: Poppins;
    font-size: 0.9rem;
    line-height: 25px;
  }

  ul li::before {
    content: "•";
    color: #0093ED;
    display: inline-block;
    width: 2em;
    margin-left: -1em;
  }

  div {
    cursor: pointer;
  }
  
  a {
    text-decoration: underline;
    color: #253EC6;
    text-underline-offset: 2px;
  }
  a:hover {
    text-decoration: none;
  }

  @media only screen and (max-width: 600px) {
    p {
      width: 100%;
    }
    padding: 15px;
  }
`;

export default function FAQList({faqs = faqsList}) {
  return (
    <section className="faq" id="faq">
      <Heading fontFamily="fonts.body" size="md" className="center bold headline-2 w-100">Frequently asked questions</Heading> <br />
      <div className="container">
        {faqs.map((faq: FAQ, index: number) => (
          <Faq key={index}>
            <FAQBlock faq={faq} />
          </Faq>
        ))}
      </div>
    </section>
  );
};

function FAQBlock({ faq }) {
  const [showAnswer, setShowAnswer] = useState(false);
  return (
    <Fragment>
      <div
        onClick={() => setShowAnswer((showAnswer) => !showAnswer)}
        className="d-flex align-items-center justify-content-between"
      >
        <Heading size="sm" fontWeight="normal" fontFamily={"font.body"}>{faq.question}</Heading>
        <img
          src={require("../../assets/icons/arrow-down.svg").default}
          alt="arrow down"
          style={showAnswer ? { transform: "rotate(180deg)" } : {}}
        />
      </div>
      {showAnswer ? (
        <>
          <br />
          <ReactMarkdown>{faq.answer?.markdown ?? faq.answer}</ReactMarkdown>
        </>
      ) : null}
    </Fragment>
  );
}
